import $ from "jquery";

import QuestionsStep from "./questions";
import QuestionView from "../../questions";
import model from "../../../models/questions";

const SkillsStep = QuestionsStep.extend({
    name: "STEP_SKILLS",
    template: false,
    postInit() {
        if (this.options.followup) {
            this.name += "_2";
        }

        let questions = [];

        if (this.options.skill) {
            questions = new model.Questions([this.options.skill]);
        } else {
            questions = new model.Questions(this.model.get("_skills") || window.questions);
            questions = questions.filter((q) => q.isSkill());
        }

        this.questions = questions.map(
            (mod) =>
                new QuestionView({
                    model: mod,
                    hideClean: this.shouldHideClean(),
                }),
        );
    },
    shouldSkip() {
        if (QuestionsStep.prototype.shouldSkip.call(this)) {
            return true;
        }

        return SkillsStep.completed;
    },
    renderHeader() {
        return "<h2>Skills and Experience</h2>";
    },
    render() {
        let html = this.renderHeader();
        this.questions.forEach((view) => {
            html += view.render().el.innerHTML;
        });
        this.attachElContent(html);
        this.onRender();
        return this;
    },
    postRender() {
        if (!this.options.isProfile && !this.options.isReview) {
            $(".next-container").show();
        }
    },
    submit() {
        let data = [];

        this.questions.forEach((view) => {
            const viewData = view.getData();
            data = data.concat(viewData);
        });

        const clean = data.reduce((s, n) => (s ? n.clean : false), true);

        if (clean) {
            // If we only have one skill, we need to merge it with the rest of the answered
            // skills so it doesn't "overwrite" what's stored on the model, which is used
            // to pre-populate skills on the review page and such.
            if (this.options.skill) {
                const qid = data[0].id;
                const skills = this.model.getSkillResponses().filter((skill) => skill.id !== qid);
                data = data.concat(skills);
            }

            this.model.set({ _skills: data }, { validate: "partial" });
            SkillsStep.completed = true;
            return true;
        }
        return false;
    },
});
SkillsStep.completed = false;

export default SkillsStep;
